import { jsx as _jsx } from "react/jsx-runtime";
import { filestore } from '@/filestore';
import { store } from '@/store';
import { updateProjectScreenshot } from '@/utils';
import { IFsFileType } from '@r3f-component-data-structure';
import React, { memo, Suspense, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Background360 from '../../r3f-components/components/Background360';
import Dummy360Content from './Dummy360Content';
const Background360Placeholder = () => {
    const activeSceneId = useSelector((state) => state.userReducer.activeSceneId);
    const componentsById = useSelector((state) => state.contentReducer?.contentDoc?.componentsById || null);
    const content360Data = activeSceneId ? componentsById[activeSceneId]?.content360 : undefined;
    const [media, setMedia] = useState({});
    const [videoStatus, setVideoStatus] = useState();
    useEffect(() => {
        if (typeof content360Data?.filestoreId === 'undefined') {
            setMedia({});
            return;
        }
        const fsFile = filestore.load(content360Data.filestoreId);
        if (fsFile.type === IFsFileType.Image360) {
            fsFile.getTexture().then(tx => {
                setMedia({ imageTexture: tx, videoUrl: undefined });
            });
        }
        else if (fsFile.type === IFsFileType.Video360) {
            setMedia({ imageTexture: undefined, videoUrl: fsFile.getPlaylistUrl() });
            fsFile.getProgressData().then(({ status }) => { setVideoStatus(status); });
        }
    }, [content360Data?.filestoreId]);
    const onTextureReady = useCallback(() => {
        const projectId = store?.getState?.()?.userReducer?.project?.id;
        if (projectId) {
            setTimeout(() => {
                updateProjectScreenshot(projectId, false);
            }, 1500);
        }
    }, []);
    const isTextureAvailable = !!media?.imageTexture || !!media?.videoUrl;
    return _jsx(Suspense, { fallback: null, children: !isTextureAvailable ?
            _jsx(Dummy360Content, { radius: 60 }) :
            _jsx(Background360, { radius: 60, enableVideoPlay: false, sceneId: activeSceneId || '', enable360Environment: Boolean(content360Data?.filestoreId), environmentRenderPriority: -5, videoStatus: videoStatus, onTextureReady: onTextureReady, media: media }) });
};
export default memo(Background360Placeholder);
